import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoindorecabs() {



const cardData = {
  keyword: " Pune to Indore Cabs ",

"headingDescription": "Pune to Indore Cabs service offers a comfortable, reliable, and hassle-free travel experience for passengers planning a journey from Pune to Indore. Whether it’s business travel, family trips, or long-distance leisure journeys, our professional drivers and well-maintained vehicles ensure a smooth ride. We provide one-way rides, round trips, and customized travel plans with transparent pricing and no hidden charges. With SRS Pune to Indore Cabs, enjoy easy online booking, 24/7 customer support, and a safe journey across states.",
"topPlaces": [
  {
    "title": "Rajwada Palace",
    "description": "Rajwada Palace is a historic landmark in Indore known for its unique architectural blend of Maratha, Mughal, and French styles. Travelers booking Pune to Indore Cabs often visit this site to explore its royal heritage."
  },
  {
    "title": "Lal Bagh Palace",
    "description": "Lal Bagh Palace reflects the grandeur of the Holkar dynasty with its impressive interiors and gardens. Visitors using Pune to Indore Cabs admire its architecture and historical significance."
  },
  {
    "title": "Sarafa Bazaar",
    "description": "Sarafa Bazaar is a famous night street food market in Indore. Travelers using Pune to Indore Cabs enjoy tasting local delicacies and experiencing the city’s vibrant food culture."
  },
  {
    "title": "Khajrana Ganesh Temple",
    "description": "Khajrana Ganesh Temple is one of the most revered temples in Indore dedicated to Lord Ganesha. Devotees traveling via Pune to Indore Cabs visit this temple to seek blessings."
  },
  {
    "title": "Annapurna Temple",
    "description": "Annapurna Temple is known for its grand entrance and spiritual significance. Visitors using Pune to Indore Cabs often explore this temple for its peaceful environment and architecture."
  },
  {
    "title": "Patalpani Waterfall",
    "description": "Patalpani Waterfall is a scenic natural attraction located near Indore, especially beautiful during monsoon. Travelers booking Pune to Indore Cabs enjoy visiting this spot for relaxation and photography."
  },
  {
    "title": "Ralamandal Wildlife Sanctuary",
    "description": "Ralamandal Wildlife Sanctuary offers nature trails and wildlife spotting opportunities. Visitors using Pune to Indore Cabs can explore this green retreat for a refreshing outdoor experience."
  },
  {
    "title": "Central Museum (Indore Museum)",
    "description": "Central Museum in Indore houses a rich collection of historical artifacts and sculptures. Travelers using Pune to Indore Cabs visit this museum to learn about the region’s history."
  },
  {
    "title": "Chappan Dukan",
    "description": "Chappan Dukan is a famous food street in Indore known for a variety of snacks and local dishes. Visitors traveling via Pune to Indore Cabs enjoy exploring this lively food hub."
  },
  {
    "title": "Gomatgiri",
    "description": "Gomatgiri is a Jain pilgrimage site with a statue of Lord Bahubali and peaceful surroundings. Travelers using Pune to Indore Cabs visit this place for spiritual calm and scenic views."
  }
],



services: [
{
name: "Pune to Indore Taxi Services",
description: "Pune to Indore taxi services provide reliable long-distance travel between Maharashtra and Madhya Pradesh. Customers can book taxis for business, family, and tourism trips. Professional drivers ensure safe highway journeys. Comfortable vehicles enhance travel experience. Transparent pricing ensures affordability. Travel smoothly from Pune to Indore with taxi services."
},
{
name: "Pune to Indore Cab Booking",
description: "Pune to Indore cab booking offers quick and easy reservation options. Customers can book cabs online or via mobile apps. Professional drivers ensure safe and timely journeys. Comfortable vehicles enhance long-distance travel comfort. Flexible booking options are available. Book your Pune to Indore cab easily."
},
{
name: "Pune to Indore Car Rental",
description: "Pune to Indore car rental provides flexible vehicle options for intercity travel. Customers can choose sedan, SUV, and premium cars. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Transparent pricing ensures affordability. Rent cars from Pune to Indore for convenient travel."
},
{
name: "Pune to Indore Rajwada Palace Cabs",
description: "Pune to Indore Rajwada Palace cabs offer convenient travel for sightseeing trips. Customers can visit historic Rajwada Palace comfortably. Professional drivers ensure safe journeys. Ideal for tourism and family trips. Flexible booking options are available. Travel easily from Pune to Indore tourist places with cab services."
},
{
name: "Pune to Indore One-Way Taxi",
description: "Pune to Indore one-way taxi provides cost-effective travel without return charges. Customers can book direct one-way rides easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Transparent pricing ensures affordability. Choose one-way taxi services for Pune to Indore travel."
},
{
name: "Pune to Indore Round Trip Cabs",
description: "Pune to Indore round trip cabs offer convenient two-way travel options. Customers can plan return journeys with flexible schedules. Comfortable vehicles ensure smooth highway travel. Professional drivers ensure safe journeys. Transparent pricing ensures budget-friendly travel. Book round trip cabs for Pune to Indore trips."
},
{
name: "Pune to Indore Luxury Taxi",
description: "Pune to Indore luxury taxi offers premium travel experience with high-end vehicles. Customers can enjoy comfortable seating and smooth journeys. Professional chauffeurs ensure safe travel. Ideal for corporate and VIP travel needs. Flexible booking options are available. Experience luxury travel from Pune to Indore."
},
{
name: "Pune to Indore Self-Drive Car Rental",
description: "Pune to Indore self-drive car rental offers freedom and flexibility for travelers. Customers can rent vehicles and drive at their own pace. Well-maintained cars ensure safe travel. Ideal for road trips and personal travel. Transparent pricing ensures affordability. Enjoy self-drive travel from Pune to Indore."
},
{
name: "Pune to Indore Private Car Hire",
description: "Pune to Indore private car hire provides personalized travel experience for passengers. Customers can enjoy private rides without sharing. Comfortable vehicles ensure smooth journeys. Professional drivers ensure safe travel. Flexible booking options are available. Travel privately from Pune to Indore with car hire services."
},
{
name: "Pune to Lal Bagh Palace",
description: "Pune to Lal Bagh Palace cab service offers convenient travel to Indore’s famous attraction. Customers can visit Lal Bagh Palace comfortably. Professional drivers ensure safe journeys. Ideal for tourists and sightseeing trips. Flexible booking options are available. Travel easily to Lal Bagh Palace from Pune with cab services."
},
{
name: "Pune to Indore Cab",
description: "Pune to Indore cab service provides reliable transportation for long-distance travel. Customers can book cabs for business and personal trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Transparent pricing ensures affordability. Travel easily from Pune to Indore with cab services."
},
{
name: "One Way Cab Pune to Indore",
description: "One way cab Pune to Indore offers economical travel without return charges. Customers can book direct one-way rides easily. Professional drivers ensure safe and timely journeys. Comfortable vehicles enhance travel comfort. Transparent pricing ensures affordability. Choose one-way cab services for Pune to Indore travel."
},
{
name: "Pune to Indore Cab Service",
description: "Pune to Indore cab service offers dependable transportation for intercity travel. Customers can book cabs for long-distance journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel conveniently with Pune to Indore cab services."
},
{
name: "Pune to Indore Taxi",
description: "Pune to Indore taxi service provides convenient transportation for travelers. Customers can book taxis for business and tourism trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel comfort. Transparent pricing ensures fair fares. Choose taxi services for Pune to Indore travel."
},
{
name: "Pune to Indore Ertiga Cab",
description: "Pune to Indore Ertiga cab offers comfortable 7-seater travel for families and groups. Customers can enjoy spacious seating for long journeys. Professional drivers ensure safe travel. Ideal for group trips. Transparent pricing ensures affordability. Travel comfortably from Pune to Indore with Ertiga cabs."
},
{
name: "Pune to Indore Innova Crysta",
description: "Pune to Indore Innova Crysta offers premium SUV travel with extra comfort and space. Customers can enjoy smooth highway journeys. Professional drivers ensure safe travel. Ideal for family and corporate travel. Transparent pricing ensures value for money. Travel comfortably with Innova Crysta services."
},
{
name: "Pune to Indore Sedan Cab Services",
description: "Pune to Indore sedan cab services provide economical and comfortable travel options. Customers can book sedans for budget-friendly journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Choose sedan cab services for Pune to Indore travel."
},
{
name: "Pune to Indore Swift Dzire on Rent",
description: "Pune to Indore Swift Dzire on rent offers affordable sedan travel for passengers. Customers can enjoy comfortable rides for long-distance journeys. Professional drivers ensure safe travel. Ideal for budget travelers. Transparent pricing ensures affordability. Travel economically from Pune to Indore with Dzire rentals."
},
{
name: "Pune to Indore Taxi Service",
description: "Pune to Indore taxi service provides reliable intercity transportation. Customers can book taxis for flexible travel plans. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Transparent pricing ensures affordability. Travel smoothly with taxi services from Pune to Indore."
},
{
name: "Pune to Indore Cab Booking",
description: "Pune to Indore cab booking offers easy reservation options for travelers. Customers can book cabs instantly online. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel comfort. Flexible booking options are available. Book your Pune to Indore cab easily."
}
],

tableData: [
["Pune to Indore Taxi Services","Pune to Indore Cab Booking"],
["Pune to Indore Car Rental","Pune to Indore Rajwada Palace Cabs"],
["Pune to Indore One-Way Taxi","Pune to Indore Round Trip Cabs"],
["Pune to Indore Luxury Taxi","Pune to Indore Self-Drive Car Rental"],
["Pune to Indore Private Car Hire","Pune to Lal Bagh Palace"],
["Pune to Indore Cab","One Way Cab Pune to Indore"],
["Pune to Indore Cab Service","Pune to Indore Taxi"],
["Pune to Indore Ertiga Cab","Pune to Indore Innova Crysta"],
["Pune to Indore Sedan Cab Services","Pune to Indore Swift Dzire on Rent"],
["Pune to Indore Taxi Service","Pune to Indore Cab Booking"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Long-Distance Drivers",
    WhyChoosedescription: "SRS Cab Service provides expert drivers experienced in long-distance routes like Pune to Indore, ensuring safe driving, proper rest planning, and a smooth journey across states."
  },
  {
    WhyChooseheading: "Affordable Pune to Indore Cab Pricing",
    WhyChoosedescription: "We offer cost-effective Pune to Indore cab services with transparent pricing. Customers receive complete fare details including tolls, state taxes, and driver allowance with no hidden charges."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 for Pune to Indore cab bookings, making it convenient for business travel, family trips, and emergency long-distance journeys."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles for Long Travel",
    WhyChoosedescription: "Our fleet includes well-maintained, air-conditioned vehicles designed for long-distance comfort, ensuring a relaxed journey from Pune to Indore."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "We offer one-way cab service, round-trip bookings, and customized travel plans for Pune to Indore journeys based on customer requirements."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for individual, family, and corporate travel."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, and Pune Airport across all major areas including Hinjewadi, Wakad, Baner, and Hadapsar."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "SRS Cab Service is trusted for Pune to Indore cab bookings due to punctual service, professional drivers, and reliable vehicles for long-distance travel."
  }
]
}

const faqData = [
  { question: "Do you provide Pune to Indore cab service?", answer: "Yes, SRS Cab Service offers reliable cab services from Pune to Indore for long-distance travel." },
  { question: "How far is Indore from Pune?", answer: "The distance between Pune and Indore is approximately 600 km and the journey takes around 10 to 12 hours depending on route and traffic." },
  { question: "Is Pune to Indore cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 for flexible long-distance travel planning." },
  { question: "Which vehicles are available for Pune to Indore travel?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, luxury Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Pune to Indore?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Do you provide multi-day travel options?", answer: "Yes, we offer customized multi-day travel plans for Pune to Indore journeys." },
  { question: "Are vehicles suitable for long-distance travel?", answer: "Yes, all vehicles are well-maintained and suitable for long-distance journeys." },
  { question: "Can I book the cab online?", answer: "Yes, you can easily book Pune to Indore cab service online or via phone." },
  { question: "Do you provide pickup from Pune home or hotel?", answer: "Yes, we provide doorstep pickup from homes, hotels, offices, and Pune Airport." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rajesh Verma",
    feedback:
      "Booked SRS Cab Service for Pune to Indore trip. Very smooth long-distance journey and driver was very professional.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Neha Sharma",
    feedback:
      "Excellent Pune to Indore cab service. Comfortable ride and perfect for long-distance family travel.",
    rating: 5
  }
];

































const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Indore Cab | SRS Cab",
  "description": "SRS Cab offers Pune to Indore cab services including one-way and round trips, luxury cabs, private car hire, and car rentals. Visit Rajwada Palace, Lal Bagh Palace, and other destinations. Book Innova Crysta, Ertiga, Sedan, or Swift Dzire cabs online with 24x7 service from Pune to Indore.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};









  return (
    <div>
      
<Helmet>
  <title>Pune to Indore Cab | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book Pune to Indore cabs with SRS Cab. One-way, round trips, luxury, private cars, and rentals. Visit Rajwada Palace, Lal Bagh Palace with Innova, Ertiga, Sedan & Swift Dzire cabs. 24x7 online booking." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/12.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoindorecabs;